// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"4185dc9b","247":"9c9c8aa2","275":"d239f356","433":"c26452a4","458":"bb7ac618","561":"b5c3b7fc","891":"a2096e8c"}[chunkId] + ".chunk.js";
};